import React from 'react';
import { RolesAccessPaginatedTable } from '@institutions/components';
import { Card, Gutter } from '@common/components';

type Props = {
  supplierId?: string;
  selectedRoles: string[];
  onRoleChange: (value: string[]) => void;
  headerSlot?: React.ReactNode;
};

export function SuppliersManagementNewSupplierStepRoles({
  supplierId,
  selectedRoles,
  onRoleChange,
  headerSlot,
}: Props) {
  return (
    <div className="suppliers-management-new-supplier-step-roles-access">
      {headerSlot && (
        <Gutter size="md" direction="bottom">
          {headerSlot}
        </Gutter>
      )}
      <Card>
        <RolesAccessPaginatedTable
          rolesAccessEditionMode
          selectedRowKeys={selectedRoles}
          setSelectedRowKeys={onRoleChange}
          supplierId={supplierId}
          hideStatusColumn
        />
      </Card>
    </div>
  );
}
